import React, { PropTypes } from 'react';

import { container } from './styles.module.css';

const Tooltip = ({ className, text }) => (
  <div className={className}>
    <div className={container}>
      {text}
    </div>
  </div>
);

export default Tooltip;

Tooltip.propTypes = {
  /**
   * String class names to append to component styles.
   */
  className: PropTypes.string,
  /**
   * Text to be rendered within component.
   */
  text: PropTypes.string.isRequired,
};

Tooltip.defaultProps = {
  className: '',
};



// WEBPACK FOOTER //
// ./app/src/components/Tooltip/index.jsx